import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0B0F17]">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-gradient-to-br from-[#0F2A6B] to-[#071640] relative grain">
        <img src="/logo.webp" alt="VISION LOGICIELS" className="h-11 w-auto bg-white rounded-lg p-2 self-start" />
        <div className="relative">
          <h1 className="text-4xl font-bold text-white font-head leading-tight">Back Office<br /><span className="text-[#4CB944]">VISION LOGICIELS</span></h1>
          <p className="mt-4 text-slate-300 max-w-md">Gérez vos solutions, services, produits, contacts, devis et campagnes depuis une plateforme unique.</p>
        </div>
        <p className="text-xs text-slate-400 relative">Une marque commerciale de PERFORM & CO · Abidjan</p>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm">
          <img src="/logo.webp" alt="VISION" className="h-10 w-auto bg-white rounded-lg p-1.5 mb-8 lg:hidden" />
          <h2 className="text-2xl font-bold text-white font-head">Connexion</h2>
          <p className="text-sm text-slate-400 mt-1">Accédez à votre espace d'administration.</p>
          <div className="mt-8 space-y-4">
            <div>
              <label className="text-sm font-medium text-slate-300">Email</label>
              <div className="mt-1.5 relative">
                <Mail className="w-4 h-4 text-slate-500 absolute left-3 top-1/2 -translate-y-1/2" />
                <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 rounded-xl bg-[#111827] border border-[#1E293B] text-white placeholder-slate-500 focus:border-[#3B82F6] focus:outline-none" placeholder="vous@visionlogiciels.com" />
              </div>
            </div>
            <div>
              <label className="text-sm font-medium text-slate-300">Mot de passe</label>
              <div className="mt-1.5 relative">
                <Lock className="w-4 h-4 text-slate-500 absolute left-3 top-1/2 -translate-y-1/2" />
                <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 rounded-xl bg-[#111827] border border-[#1E293B] text-white placeholder-slate-500 focus:border-[#3B82F6] focus:outline-none" placeholder="••••••••" />
              </div>
            </div>
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full mt-6 flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-[#3B82F6] text-white font-semibold hover:bg-[#2563EB] disabled:opacity-60">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}{loading ? "Connexion…" : "Se connecter"}
          </button>
          <a href="/" className="block text-center mt-6 text-sm text-slate-500 hover:text-slate-300">← Retour au site</a>
        </form>
      </div>
    </div>
  );
}
